import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchContextsSuggestionsArgs, SearchSuggestionsOutput } from "types/generated";
import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

type SearchContextsSuggestionsData = {
  searchContextsSuggestions: SearchSuggestionsOutput;
};

export const GET_CONTEXT_SUGGESTIONS: TypedDocumentNode<
  SearchContextsSuggestionsData,
  QuerySearchContextsSuggestionsArgs
> = gql`
  query GetContextSuggestions($input: SearchSuggestionsInput!) {
    searchContextsSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
